import LoginModal from './LoginModal';
import './LoginModal.scss';

export default LoginModal;
